// 开发环境
// export const baseUrl = "http://192.168.1.92:8080"
// export const baseUrl = "http://localhost:8080"

// 生产环境
export const baseUrl = "/gene-search"

export default {
    search: {
        getListBySearchForm: "/get",
        getDetailById: "/getById",
        getByIdForDetail: "/getByIdForDetail",
        getSelectListName:"/getSelectListName"
    },
    submit: {
        addGene: "/add",
        addNull: "/addNull",
        addNullMutations: "/addNullMutations"
    },
    user: {
        login: "/user/login"
    },
    update: {
        getById: "/getById",
        updateGene: "/update",
    },
    getNumP: {
        getNumP: "/getNumP"
    },
    getNumO: {
        getNumO: "/getNumO"
    },
    getNumT: {
        getNumT: "/getNumT"
    },
    getNumF: {
        getNumF: "/getNumF"
    },
    insertPmid: {
        insertPmid: "/insertPmid"
    },
    getPmid: {
        getPmid: "/getPmid",
        getContentByPmidId: "/getContentByPmidId",
    },
    getByGeneId:{
        getByGeneId: "/getByGeneId"
    }

}



// WEBPACK FOOTER //
// ./src/utils/url.js